module.exports = __webpack_public_path__ + "img/Assiettes_de_mariage.d4a300a.jpg";